module.exports = __webpack_public_path__ + "static/apoorv-4923a22aefaf0f215a8778dca2348b4c.jpg";